<script setup lang="ts">
withDefaults(
  defineProps<{
    /** How large should the text be? */
    size?: keyof typeof sizeMapping
    /** How bold should the text be? */
    weight?: keyof typeof weightMapping
    /** What HTML tag should be used to render the text? */
    tag?: string
    /** What text should be displayed?<br/>(Can also be provided via the slot.) */
    text?: string
  }>(),
  {
    size: 'default',
    weight: 'regular',
    tag: 'p'
  }
)

const sizeMapping = {
  default: 'text-body',
  sm: 'text-body-sm',
  xs: 'text-body-sm sm:text-body-xs'
} as const

const weightMapping = {
  regular: 'font-sans font-normal',
  medium: 'font-sans font-medium',
  bold: 'font-sans font-bold'
} as const
</script>

<template>
  <component :is="tag" :class="[weightMapping[weight], sizeMapping[size]]">
    {{ text }}
    <slot v-if="!text" />
  </component>
</template>
